/**
 * Découpe une saisie utilisateur en jetons d’e-mail (séparateurs : espaces, virgule, point-virgule).
 * Aligné sur la validation côté tableau de bord (invitation propriétaire d’organisation).
 */
export function parseEmailTokens(raw: string): string[] {
  return raw
    .split(/[,;\s]+/)
    .map(s => s.trim())
    .filter(Boolean);
}
